import React from 'react';

import Close from '../../assets/icon-close-white.svg';

class priceLimit extends React.Component {
    UNSAFE_componentWillMount() {
        document.body.classList.add('overlay-hide');
    }
    componentWillUnmount() {
        document.body.classList.remove('overlay-hide');
    }

    render() {
        return (
            <div className="modal">
                <div className="popup-exit">
                    <div className="modal-body">
                        <div className="popup-header">
                            <h3>Price Limit Exceeded</h3>
                        </div>
                        <p>Get food on your train. Order now in just 3 easy steps</p>
                        <a href="tel:+918137813700"  className="continue" id="continuewith" >Contact Support Team</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default priceLimit;